import { useState } from "react";
import { GridApi } from "ag-grid-community";
import ActiveRulesGrid from "./ActiveRulesGrid";
import ExpandModal from "@modals/ExpandModal";
import RulesSelectFilter from "./RulesSelectFilter";
import { FaExpandAlt } from "react-icons/fa";

const ActiveRulesComponent = () => {
    const modalTitle = "Active Rules";
    const [show, setShow] = useState(false);
    const [gridApi, setGridApi] = useState<GridApi>();
    const componentType = "table";

    return (
        <>
            <div
                className="col-12 col-sm-12 col-md-6 mb-md-0"
                id="rules_div"
                style={{ height: "100%", width: "100%" }}
            >
                <div
                    className="card h-100 shadow"
                    style={{ borderRadius: "16px" }}
                >
                    <div
                        className="card-body p-2"
                        style={{ borderRadius: "16px" }}
                    >
                        <div className="d-flex align-items-center justify-content-between px-2 pt-1">
                            <h5>{modalTitle}</h5>
                            <div className="d-flex align-items-center justify-content-right">
                                <RulesSelectFilter gridApi={gridApi} />
                                <FaExpandAlt className="mx-1"
                                    style={{
                                        fontSize: "1.1rem",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setShow(true)} />
                            </div>
                        </div>
                        <div
                            className="border-top pt-2 mt-2"
                            id="active-rules-report-render"
                        />
                        <ActiveRulesGrid
                            componentType={componentType}
                            setGridApi={setGridApi}
                        />
                    </div>
                </div>
            </div>
            <ExpandModal
                show={show}
                setShow={setShow}
                modalTitle={modalTitle}
            />
        </>
    );
};

export default ActiveRulesComponent;
